import {
  EditEmployeeModal,
  EditRoleModal,
  EditUserModal
} from './components'

export const headerMap = {
  roles: ['角色名稱', '角色代碼', '狀態', '修改日期'],
  users: ['帳號', '姓名', '員工編號', 'E-Mail', '電話', '角色', '狀態', '新增日期'],
  employees: ['員工編號', '員工姓名', '到職日', '狀態', '新增日期'],
  'api-logs': ['使用者代碼', '使用功能', '參數', '日期']
}

export const fieldOrderMap = {
  roles: ['description', 'code', 'status', 'updatedAt'],
  users: ['account', 'name', 'employeeNo', 'email', 'mobile', 'role', 'status', 'createdAt'],
  employees: ['employeeNo', 'name', 'arrivalDate', 'status', 'createdAt'],
  'api-logs': ['userName', 'fnCode', 'request', 'createdAt']
}

export const titleMap = {
  roles: '角色管理',
  users: '使用者管理',
  employees: '員工管理',
  'api-logs': '系統Log'
}

export const editModalMap = {
  employees: EditEmployeeModal,
  roles: EditRoleModal,
  users: EditUserModal
}
